module.exports = __webpack_public_path__ + "img/eler.ce724c7c.jpg";